"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "icons", {
  enumerable: true,
  get: function get() {
    return _icons["default"];
  }
});

var _Popover2 = _interopRequireDefault(require("@material-ui/core/Popover"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Add2 = _interopRequireDefault(require("@material-ui/icons/Add"));

var _dataGrid = _interopRequireDefault(require("@kontenbase/data-grid"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactContextmenu = require("react-contextmenu");

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _MultiSelectMenu = _interopRequireDefault(require("./components/MultiSelectMenu"));

var _SingleSelectMenu = _interopRequireDefault(require("./components/SingleSelectMenu"));

var _DraggableRow = _interopRequireDefault(require("./DraggableRow"));

var _editors = require("./editors");

var _formatters = require("./formatters");

var _Group = _interopRequireDefault(require("./formatters/Group"));

var _headers = require("./headers");

var _CustomizeField = _interopRequireDefault(require("./headers/CustomizeField"));

var _DeleteField = _interopRequireDefault(require("./headers/DeleteField"));

var _DuplicateField = _interopRequireDefault(require("./headers/DuplicateField"));

var _icons = _interopRequireDefault(require("./icons"));

var _RowMenu = _interopRequireDefault(require("./ContextMenu/RowMenu"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function MejikTable(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows,
      onRowsChange = _ref.onRowsChange,
      onRowReorder = _ref.onRowReorder,
      onColumnResize = _ref.onColumnResize,
      onColumnsReorder = _ref.onColumnsReorder,
      onScroll = _ref.onScroll,
      groupBy = _ref.groupBy,
      selectedRows = _ref.selectedRows,
      setSelectedRows = _ref.setSelectedRows,
      isEditable = _ref.isEditable,
      isEmbed = _ref.isEmbed,
      onClickAdd = _ref.onClickAdd,
      onClickContextDelete = _ref.onClickContextDelete,
      handleDeleteSelected = _ref.handleDeleteSelected;

  var _useState = (0, _react.useState)(new Set()),
      _useState2 = _slicedToArray(_useState, 2),
      expandedGroupIds = _useState2[0],
      setExpandedGroupIds = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  var calculateTotal = function calculateTotal(rows) {
    var sumRow = {
      id: "count",
      count: rows.length - 1
    };
    return [sumRow];
  };

  function rowHeight(arg) {
    if (arg.type === "GROUP") {
      return 42;
    }

    if (arg.row.id === "DIVIDER") {
      return 20;
    }

    return 30;
  }

  function groupByKey(array, key) {
    var data = array.filter(function (item) {
      return item._id !== "create";
    }).reduce(function (hash, obj) {
      var group = _typeof(obj[key]) === "object" || Array.isArray(obj[key]) ? JSON.stringify(obj[key]) : obj[key];
      var data = (hash[group] || []).concat(obj);
      return Object.assign(hash, _defineProperty({}, group, data));
    }, {});

    if (Array.isArray(groupBy) && groupBy[groupBy.length - 1] === key) {
      Object.keys(data).forEach(function (item) {
        data[item].push({
          _id: "create-".concat(key, "-").concat(item),
          _group: {
            key: key,
            value: data[item][0][key]
          },
          no: /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
            size: "small",
            onClick: function onClick() {
              return onClickAdd(_defineProperty({}, key, data[item][0][key]));
            },
            style: {
              marginLeft: 6
            }
          }, /*#__PURE__*/_react["default"].createElement(_Add2["default"], {
            fontSize: "small"
          }))
        });
      });
    }

    return data;
  }

  var getColumns = (0, _react.useCallback)(function (data) {
    var result = data.map(function (item) {
      var key = item.key;
      var name = item.name;
      var type = item.type;
      var editor = isEditable ? (0, _editors.getEditor)(type) : null;
      return _objectSpread(_objectSpread({}, item), {}, {
        name: name,
        key: key,
        editor: editor,
        onColumnsReorder: onColumnsReorder,
        isEditable: isEditable,
        isEmbed: isEmbed,
        setState: setState,
        editable: editor === null ? false : true,
        type: type,
        width: item.width,
        maxWidth: item.maxWidth,
        options: item.options,
        frozen: item.frozen,
        formatter: (0, _formatters.getFormatter)(item.type),
        headerRenderer: (0, _headers.getHeader)(item.type),
        groupFormatter: _Group["default"]
      });
    });

    if (groupBy !== null && groupBy !== void 0 && groupBy.length) {
      var groupColumns = new Array(groupBy.length).fill().map(function (_, index) {
        return {
          key: "GROUP-".concat(index),
          width: 200,
          name: "",
          frozen: true,
          groupFormatter: _Group["default"]
        };
      });
      return [].concat(_toConsumableArray(groupColumns), _toConsumableArray(result));
    }

    return result;
  }, [groupBy, isEditable, isEmbed, onColumnsReorder]);

  var handleCloseSelected = function handleCloseSelected() {
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        openHeaderMenu: null,
        key: null,
        column: null
      });
    });
  };

  var summaryRows = (0, _react.useMemo)(function () {
    return calculateTotal(rows);
  }, [rows]);
  var memoRows = (0, _react.useMemo)(function () {
    return rows;
  }, [rows]);
  var memoColumns = (0, _react.useMemo)(function () {
    return getColumns(columns);
  }, [columns, getColumns]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactDnd.DndProvider, {
    backend: _reactDndHtml5Backend.HTML5Backend
  }, /*#__PURE__*/_react["default"].createElement(_dataGrid["default"], {
    columns: memoColumns,
    rows: memoRows,
    selectedRows: selectedRows,
    onSelectedRowsChange: setSelectedRows,
    summaryRows: summaryRows,
    onRowsChange: onRowsChange,
    onScroll: onScroll,
    enableVirtualization: true,
    rowKeyGetter: function rowKeyGetter(row) {
      return row.id || row._id;
    },
    rowRenderer: function rowRenderer(p) {
      return /*#__PURE__*/_react["default"].createElement(_reactContextmenu.ContextMenuTrigger, {
        id: "grid-context-menu",
        collect: function collect() {
          return {
            p: p,
            rowIdx: p.rowIdx,
            id: p.row.id || p.row._id
          };
        }
      }, /*#__PURE__*/_react["default"].createElement(_DraggableRow["default"], _extends({}, p, {
        onRowReorder: onRowReorder
      })));
    },
    defaultColumnOptions: {
      resizable: true
    },
    style: {
      height: "100%"
    },
    groupBy: groupBy,
    rowGrouper: groupByKey,
    theme: "kontenbase",
    rowHeight: rowHeight,
    expandedGroupIds: expandedGroupIds,
    onExpandedGroupIdsChange: setExpandedGroupIds,
    onColumnResize: onColumnResize,
    summaryRowHeight: 28,
    headerRowHeight: 32
  }), /*#__PURE__*/_react["default"].createElement(_RowMenu["default"], {
    handleDelete: onClickContextDelete,
    selectedRows: selectedRows,
    handleDeleteSelected: handleDeleteSelected
  })), /*#__PURE__*/_react["default"].createElement(_Popover2["default"], {
    anchorEl: state.openHeaderMenu,
    open: Boolean(state.openHeaderMenu),
    onClose: handleCloseSelected,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, state.key === "customize" && /*#__PURE__*/_react["default"].createElement(_CustomizeField["default"], {
    column: state.column,
    onClose: handleCloseSelected
  }), state.key === "delete" && /*#__PURE__*/_react["default"].createElement(_DeleteField["default"], {
    column: state.column,
    onClose: handleCloseSelected
  }), state.key === "duplicate" && /*#__PURE__*/_react["default"].createElement(_DuplicateField["default"], {
    column: state.column,
    onClose: handleCloseSelected
  })), /*#__PURE__*/_react["default"].createElement(_MultiSelectMenu["default"], {
    row: state.row,
    column: state.column,
    anchorEl: state.openMultiSelectMenu,
    rowIdx: state.rowIdx,
    onClose: function onClose() {
      return setState(function (s) {
        return _objectSpread(_objectSpread({}, s), {}, {
          openMultiSelectMenu: false,
          column: null,
          row: null
        });
      });
    },
    onRowChange: function onRowChange(value) {
      var updatedRows = _toConsumableArray(memoRows);

      updatedRows[state.rowIdx] = value;
      onRowsChange(updatedRows, {
        indexes: [state.rowIdx],
        column: state.column
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_SingleSelectMenu["default"], {
    row: state.row,
    column: state.column,
    anchorEl: state.openSingleSelectMenu,
    rowIdx: state.rowIdx,
    onClose: function onClose() {
      return setState(function (s) {
        return _objectSpread(_objectSpread({}, s), {}, {
          openSingleSelectMenu: false,
          column: null,
          row: null
        });
      });
    },
    onRowChange: function onRowChange(value) {
      var updatedRows = _toConsumableArray(memoRows);

      updatedRows[state.rowIdx] = value;
      onRowsChange(updatedRows, {
        indexes: [state.rowIdx],
        column: state.column
      });
    }
  }));
}

MejikTable.propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string,
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    width: _propTypes["default"].number,
    maxWidth: _propTypes["default"].number,
    frozen: _propTypes["default"].bool,
    hideMenu: _propTypes["default"].bool,
    options: _propTypes["default"].object,

    /**
     * Handle click button in header menu.
     * e.g Save add column or update column.
     */
    onSave: _propTypes["default"].func,

    /**
     * Handle click button add in row.
     * e.g Add relation in Link to record.
     */
    onClickAdd: _propTypes["default"].func,

    /**
     * Handle click button delete in row.
     * e.g Delete relation in Link to record.
     */
    onClickDelete: _propTypes["default"].func,

    /**
     * Handle get data styles.
     * e.g get list type in checkbox.
     */
    getStyles: _propTypes["default"].func,

    /**
     * Handle get data.
     * e.g get data tables, fields, etc.
     */
    getData: _propTypes["default"].func,
    summaryFormatter: _propTypes["default"].func
  })),
  rows: _propTypes["default"].array,
  onRowsChange: _propTypes["default"].func,
  onRowReorder: _propTypes["default"].func,
  onColumnResize: _propTypes["default"].func,
  onColumnsReorder: _propTypes["default"].func,
  onScroll: _propTypes["default"].func,
  onClickAdd: _propTypes["default"].func,
  onClickContextDelete: _propTypes["default"].func,
  setSelectedRows: _propTypes["default"].func,
  handleDeleteSelected: _propTypes["default"].func,
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].string),
  groupBy: _propTypes["default"].arrayOf(_propTypes["default"].string),
  isEditable: _propTypes["default"].bool,

  /**
   * If `true`, the component is table embed.
   */
  isEmbed: _propTypes["default"].bool
};
MejikTable.defaultProps = {
  onRowsChange: function onRowsChange() {},
  onRowReorder: function onRowReorder() {},
  onClickAdd: function onClickAdd() {},
  onClickContextDelete: function onClickContextDelete() {},
  handleDeleteSelected: function handleDeleteSelected() {},
  isEmbed: true,
  isEditable: true
};
var _default = MejikTable;
exports["default"] = _default;